import { render } from "./CurtainFeedback.vue?vue&type=template&id=1ace7b05"
import script from "./CurtainFeedback.vue?vue&type=script&lang=js"
export * from "./CurtainFeedback.vue?vue&type=script&lang=js"
script.render = render

export default script